import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import login from './modules/login/login/index.js';
import investor from './modules/filters/investor/index.js';
import structurer from './modules/filters/structurer/index.js';
import forgotPassword from './modules/login/forgotPassword/index.js';
import userManagement from './modules/userManagement/index.js';
import investorManagement from './modules/investorManagement/index.js';
import originatorManagement from './modules/originatorManagement/index.js';
import offerManagement from './modules/offerManagement/index.js';
import configManagement from './modules/configManagement/index.js';
import operationTypeManagement from './modules/operationTypeManagement/index.js';
import docTypeManagement from './modules/docTypeManagement/index.js';
import docSubtypeManagement from './modules/docSubtypeManagement/index.js';
import industryManagement from './modules/industryManagement/index.js';
import offerStatusManagement from './modules/offerStatusManagement/index.js';

Vue.use(Vuex);

const dataState = createPersistedState({ storage: window.sessionStorage });

const store = new Vuex.Store({
	modules: {
		login,
		investor,
		structurer,
		forgotPassword,
		userManagement,
		investorManagement,
		originatorManagement,
		offerManagement,
		configManagement,
		operationTypeManagement,
		industryManagement,
		offerStatusManagement,
		docTypeManagement,
		docSubtypeManagement,
	},
	plugins: [dataState],
});

export default store;
